






import { Component, Vue } from 'vue-property-decorator';
import DeviceActivationForm from '@/components/DeviceActivationForm.vue';

@Component({
  components: {
    DeviceActivationForm,
  },
})
export default class DeviceActivation extends Vue {}
